import React from 'react'
import { Outlet } from 'react-router-dom'

import {
    EnumGlobalRoutes,
    EnumTenantAdminRoutes,
    ROUTE_TITLES_CONSTANT,
} from '../app/router/routerConstants'
import ChatIcon from '../assets/img/ico-chat.svg?react'
import GridsIcon from '../assets/img/ico-grids.svg?react'
import NotificationIcon from '../assets/img/ico-notification.svg?react'
import TeamManagementIco from '../assets/img/ico-team-management.svg?react'
import UserManagementIco from '../assets/img/ico-user-management.svg?react'
import WorkGroupIco from '../assets/img/ico-work-group-management.svg?react'
import ServiceIco from '../assets/img/service-management.svg?react'
import Header from '../compoments/layout/Header'
import Sidebar from '../compoments/layout/Sidebar'

export const TenantAdminLayout = () => {
    const pages = [
        {
            icon: <GridsIcon />,
            title: ROUTE_TITLES_CONSTANT[EnumGlobalRoutes.DASHBOARD],
            url: EnumGlobalRoutes.DASHBOARD,
        },
        {
            icon: <ServiceIco />,
            title: ROUTE_TITLES_CONSTANT[
                EnumTenantAdminRoutes.TENANT_ADMIN_SERVICE_MANAGEMENT
            ],
            url: EnumTenantAdminRoutes.TENANT_ADMIN_SERVICE_MANAGEMENT,
        },
        {
            icon: <UserManagementIco />,
            title: ROUTE_TITLES_CONSTANT[
                EnumTenantAdminRoutes.TENANT_ADMIN_USER_MANAGEMENT
            ],
            url: EnumTenantAdminRoutes.TENANT_ADMIN_USER_MANAGEMENT,
        },
        {
            icon: <TeamManagementIco />,
            title: ROUTE_TITLES_CONSTANT[
                EnumTenantAdminRoutes.TENANT_ADMIN_TEAM_MANAGEMENT
            ],
            url: EnumTenantAdminRoutes.TENANT_ADMIN_TEAM_MANAGEMENT,
        },
        {
            icon: <WorkGroupIco />,
            title: ROUTE_TITLES_CONSTANT[
                EnumTenantAdminRoutes.TENANT_ADMIN_WORKGROUP_MANAGEMENT
            ],
            url: EnumTenantAdminRoutes.TENANT_ADMIN_WORKGROUP_MANAGEMENT,
        },
        {
            icon: <NotificationIcon />,
            title: ROUTE_TITLES_CONSTANT[EnumGlobalRoutes.NOTIFICATION],
            url: EnumGlobalRoutes.NOTIFICATION,
        },
        {
            icon: <ChatIcon />,
            title: ROUTE_TITLES_CONSTANT[EnumGlobalRoutes.CHAT],
            url: EnumGlobalRoutes.CHAT,
        },
    ]

    return (
        <>
            <Header />
            <Sidebar pages={pages} />
            <div className="wrapper header-fixed sidebar-indentation">
                <Outlet />
            </div>
        </>
    )
}
